import { usePrettyNumber } from '@/hooks/usePrettyNumber'

type SelectedPriceDisplayProps = {
  amount: number
  currency: string
  isLowest: boolean
  showComparison: boolean
}

export const SelectedPriceDisplay = ({
  amount,
  currency,
  isLowest,
  showComparison,
}: SelectedPriceDisplayProps) => {
  const prettyNumber = usePrettyNumber()

  const { dollars, cents } = dollarsAndCents({
    amount,
    prettyNumber,
  })

  return (
    <div className="flex font-mono leading-none items-start gap-x-1">
      <span className="text-[1.65rem]">${dollars}</span>
      <span className="underline">{cents}</span>
      <span>{currency.toUpperCase()}</span>
    </div>
  )
}

function dollarsAndCents({
  amount,
  prettyNumber,
}: {
  amount: number
  prettyNumber: (value: string) => string
}) {
  const [dollars, cents] = String(amount?.toFixed(2)).split('.')

  return {
    dollars: dollars ? prettyNumber(dollars) : '0',
    cents: cents ? cents.padEnd(2, '0') : '00',
  }
}
